import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getTestimonials,
  approveTestimonial,
  disapproveTestimonial,
} from "../../api/testimonialService";
import { getErrorMessage } from "../../utils/errorHandler";
import Pagination from "../Pagination/Pagination";

export default function TestimonialList() {
  const navigate = useNavigate();
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const fetchTestimonials = async (page = 1) => {
    setLoading(true);

    try {
      const res = await getTestimonials(page, itemsPerPage);
      setTestimonials(res?.data?.testimonials || []);
      setTotalItems(res?.data?.totalItems || 0);
      setTotalPages(res?.data?.totalPages || 1);
    } catch (error) {
      alert(getErrorMessage(error));
      setTestimonials([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTestimonials(currentPage);
  }, [currentPage]);

  const handleApprove = async (id) => {
    try {
      await approveTestimonial(id);

      alert("Testimonial approved successfully");

      fetchTestimonials(currentPage);
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };

  const handleDisapprove = async (id) => {
    try {
      await disapproveTestimonial(id);

      alert("Testimonial disapproved successfully");

      fetchTestimonials(currentPage);
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Testimonials List</h5>
      </div>

      {loading && <p>Loading testimonials...</p>}

      {!loading && testimonials.length === 0 && (
        <p className="text-muted">No Testimonials Found</p>
      )}

      <div className="row">
        {testimonials.map((testimonial) => (
          <div
            key={testimonial._id}
            className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4"
          >
            <div className="card shadow-sm h-100 border-0">
              <div className="card-body">
                {/* Product Image */}
                <div className="text-center mb-3">
                  <img
                    src={testimonial.imageUrls[0]}
                    alt={testimonial.productName}
                    className="rounded"
                    width="100"
                    height="100"
                    style={{ objectFit: "cover" }}
                  />
                </div>

                {/* Customer Name */}
                <h5 className="text-center mb-1">{testimonial.name}</h5>

                {/* Location */}
                <p className="text-center text-muted mb-2">
                  {testimonial.city}, {testimonial.state}
                </p>

                {/* Product */}
                <div className="text-center mb-2">
                  <strong>{testimonial.productName}</strong>
                </div>

                {/* Rating */}
                <div className="text-center mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i
                      key={star}
                      className={`fa ${
                        star <= testimonial.rating
                          ? "fa-star text-warning"
                          : "fa-star-o text-muted"
                      }`}
                    />
                  ))}
                </div>

                {/* Review */}
                <p
                  className="text-muted"
                  style={{
                    minHeight: "90px",
                    overflow: "hidden",
                  }}
                >
                  {testimonial.review}
                </p>

                {/* Actions */}
                <div className="d-flex justify-content-center gap-2">
                  {testimonial.status !== "APPROVED" &&
                    testimonial.status !== "DISAPPROVED" && (
                      <div className="d-flex justify-content-center gap-2">
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => handleApprove(testimonial._id)}
                        >
                          Approve
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDisapprove(testimonial._id)}
                        >
                          Disapprove
                        </button>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {!loading && totalItems > 0 && (
        <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </div>
  );
}
